import React from 'react'

const PatientPage = () => {
  return (
    <div>
    Patient Page
    </div>
      
  )
}

export default PatientPage
